import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "src/styles/styles.scss";
import "@gqlapp/global";
import Router from "next/router";
import Base from "next/app";
import mergeObject from "@gqlapp/base/utils/merge/mergeObject";
import initializeApollo from "@gqlapp/core-common/init";
import withApollo from "next-with-apollo";
import { CacheProvider } from "@emotion/react";
import { ApolloProvider, getDataFromTree } from "react-apollo";
// import { ApolloProvider } from '@apollo/react-common';
// import { getDataFromTree } from "@apollo/client/react/ssr";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import createEmotionCache from "../createEmotionCache";
import theme from "../theme";
//Route Events.
import NProgress from "nprogress"; //nprogress module
NProgress.configure({
    showSpinner: false
});
Router.events.on("routeChangeStart", ()=>{
    NProgress.start();
    NProgress.set(0.8);
});
let timeout = null;
Router.events.on("routeChangeComplete", ()=>{
    clearTimeout(timeout);
    timeout = setTimeout(NProgress.done, 100);
});
Router.events.on("routeChangeError", ()=>NProgress.done());
// try{ process.on('warning', e => console.warn(e.stack)); }catch (e) {}
import createReduxStore from "@gqlapp/core-common/createReduxStore";
// @ts-ignore
import { Provider } from "react-redux";
import NotificationProvider from "@xem/look/Notification";
import clientModules from "@xem/client";
// @ts-ignore
import settings from "@xem/config/settings";
import { URLPattern } from "urlpattern-polyfill";
(async ()=>await clientModules.createApp(module))();
// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();
function AppComponent(param) {
    let { Component: BaseComponent , pageProps , apollo , emotionCache =clientSideEmotionCache  } = param;
    // console.warn('#######','AppComponent','XXX#', pageProps);
    try {
        const jssStyles = document.querySelector("#jss-server-side");
        if (jssStyles && jssStyles.parentNode) jssStyles.parentNode.removeChild(jssStyles);
    } catch (e) {}
    settings.init();
    let req = pageProps.req;
    // @ts-ignore
    delete pageProps.res;
    delete pageProps.req;
    delete pageProps.apolloClient;
    pageProps = {
        ...pageProps,
        loadbar: NProgress
    };
    const store = createReduxStore(clientModules.reducers, {}, apollo);
    // @ts-ignore
    const Component = (props)=>clientModules.getWrappedRoot(/*#__PURE__*/ _jsx(BaseComponent, {
            ...props
        }), req);
    const ComponentWithProvider = ()=>{
        // @ts-ignore
        return /*#__PURE__*/ _jsx(Provider, {
            store: store,
            children: /*#__PURE__*/ _jsx(ApolloProvider, {
                client: apollo,
                children: /*#__PURE__*/ _jsx(NotificationProvider, {
                    ...pageProps,
                    children: (param)=>/*#__PURE__*/ {
                        let { alert  } = param;
                        return _jsx(Component, {
                            ...pageProps,
                            alert
                        });
                    }
                })
            })
        });
    };
    // @ts-ignore
    if (isTrue("DEBUG")) {
        let start_time = pageProps === null || pageProps === void 0 ? void 0 : pageProps.start_time;
        let end_time = new Date().getTime(), run_time = end_time - start_time;
        error("####### APP Page", {
            start_time,
            end_time,
            run_time
        });
    }
    return /*#__PURE__*/ _jsx(CacheProvider, {
        value: emotionCache,
        children: /*#__PURE__*/ _jsxs(ThemeProvider, {
            theme: theme,
            children: [
                /*#__PURE__*/ _jsx(CssBaseline, {}),
                /*#__PURE__*/ _jsx(ComponentWithProvider, {})
            ]
        })
    });
}
/**
 * getInitialProps
 * @param appContext
 */ AppComponent.getInitialProps = async (appContext)=>{
    var ref, ref1, ref2, ref3;
    let start_time = new Date().getTime();
    /** set default header* */ serverSideProps(appContext.ctx);
    /**
   * load default args
   */ let headers = ((ref = appContext.ctx) === null || ref === void 0 ? void 0 : ref.headers) || {};
    let pathname = ((ref1 = appContext.ctx) === null || ref1 === void 0 ? void 0 : ref1.pathname) || "";
    let query = ((ref2 = appContext.ctx) === null || ref2 === void 0 ? void 0 : ref2.query) || {};
    let asPath = ((ref3 = appContext.ctx) === null || ref3 === void 0 ? void 0 : ref3.asPath) || "";
    let path = asPath;
    // debug('######', { pathname, asPath, query })
    const pattern = new URLPattern({
        pathname: "(.*)/:page/page(.html|)"
    });
    let res = pattern.exec({
        pathname: asPath
    });
    if (res) {
        const { pathname: pathname1  } = res || {};
        path = pathname1.input;
        let groups = pathname1.groups;
        for(let i = 0; i < 50; i++){
            groups["".concat(i)] && delete groups["".concat(i)];
        }
        Object.assign(query, {
            ...groups
        });
    // debug('#####APP', res);
    }
    path = "".concat(path).replace(".html", "");
    path = "".concat(path).replace(/\/\d+\/page$/g, "");
    let { page  } = query || {};
    Object.assign(query, {
        page: parseInt(page || 0)
    });
    let route_type;
    try {
        let routes = clientModules.route || {};
        // debug({ routes })
        Object.keys(routes).map((key)=>{
            var ref, ref1;
            let pathname = (ref = routes[key]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.path;
            pathname = "".concat(pathname).replace(".html", "");
            if (pathname) {
                // debug('######', { pathname, asPath, path, query, route_type })
                const pattern = new URLPattern({
                    pathname
                });
                let res = pattern.exec({
                    pathname: path
                });
                if (res) {
                    try {
                        route_type = key;
                        let groups = res.pathname.groups || {};
                        Object.assign(query, groups);
                    } catch (e) {}
                }
            }
        });
    } catch (e) {}
    // debug('######', { pathname, asPath, path, query, route_type })
    // console.warn("\n\n\n\n\n\n");
    Object.assign(appContext.ctx, {
        start_time,
        path,
        asPath,
        query,
        route_type
    });
    if (isTrue("DEBUG")) {
        error("##############");
    }
    let pageProps = await Base.getInitialProps(appContext);
    if (isTrue("DEBUG")) {
        let end_time = new Date().getTime(), run_time = end_time - start_time;
        error("####### APP", {
            start_time,
            end_time,
            run_time
        });
    }
    /**
   * Assign default args
   */ return mergeObject({
        query,
        headers,
        path,
        asPath,
        pathname
    }, pageProps);
};
export default withApollo((param)=>{
    let { initialState , ...ctx } = param;
    return initializeApollo({
        initialState,
        clientModules
    }, ctx);
}, {
    getDataFromTree
})(AppComponent);
